module.exports = __webpack_public_path__ + "img/3.30_Russian_road_sign.a99114c4.svg";